<div class="modal-container">
  <h2 mat-dialog-title>Create New Organization</h2>
  
  <mat-dialog-content>
    <form [formGroup]="organizationForm">
      
      <mat-form-field appearance="outline" class="formField">
        <mat-label>Organization Name</mat-label>
        <input matInput formControlName="name" placeholder="Enter organization name">
        <mat-error *ngIf="organizationForm.get('name')?.hasError('required')">
          Organization name is required
        </mat-error>
        <mat-error *ngIf="organizationForm.get('name')?.hasError('maxlength')">
          Name must be less than 256 characters
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="formField">
        <mat-label>Organization Type</mat-label>
        <mat-select formControlName="organizationTypeId">
          <mat-option *ngFor="let type of organizationTypes$ | async" [value]="type.id">
            {{ type.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="organizationForm.get('organizationTypeId')?.hasError('required')">
          Organization type is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="formField">
        <mat-label>Registry</mat-label>
        <input matInput [value]="defaultRegistry.name" readonly>
      </mat-form-field>


      <div *ngIf="isSuperAdmin$ | async" class="test-org-toggle">
        <mat-checkbox
          color="primary"
          formControlName="isTestOrganization">
          Test Organization
        </mat-checkbox>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions">
    <button 
      mat-button 
      color="primary" 
      class="save-btn"
      (click)="onSave()" 
      [disabled]="organizationForm.invalid || isLoading">
      {{ isLoading ? 'Creating...' : 'Create Organization' }}
    </button>
    <button mat-button type="button" class="cancel-btn" (click)="onCancel()">
      Cancel
    </button>

  </mat-dialog-actions>
</div>